import React, {useEffect} from "react"
import {useNavigate} from "react-router-dom";
import Container from '@mui/material/Container';
import {Link} from "react-router-dom";
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import {
  ButtonTypeEnum, ButtonSizeEnum
} from "app/components/shared/enums/global-enums.tsx";
import AppButton from "app/components/shared/AppButton/AppButton.tsx";

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {useTranslation} from 'react-i18next'
import Footer from "app/components/shared/Footer/Footer";
import Navbar from "app/components/shared/Navbar/Navbar.tsx";
import {AppRoutes} from "app/helpers/routes";
import demo from "app/assets/images/demo.gif"
import useStore from 'app/store/store'
import './SignUp.scss'

const SignUpSchema = Yup.object().shape({
  first_name: Yup.string()
    .required('Required'),
  last_name: Yup.string()
    .required('Required'),
  email: Yup.string().required('Required').email()
});

export default function SignUp (){

  const {t} = useTranslation();
  const navigate = useNavigate();

  const storeActions = useStore((state)=> state.actions);
  
  // const universities = useStore((state) => state.universities);
  const accessToken = storeActions.retrieveItem("user-access-token");

  const initValues = {
            first_name: '',
            last_name: '',
            email: '',
          };


  useEffect(() =>{
    storeActions.fetchUniversities();
  }, [storeActions]);


  useEffect(() =>{
    if (accessToken) {
      navigate(AppRoutes.dashboardPath);
    }
  }, [navigate, accessToken]);

  return (
    <>
      <Navbar/>
      <Container maxWidth="xl" >
        <div className="v-space-5"></div>
        <Grid container spacing={5}>
          <Grid item lg={7}>
            <Formik
              enableReinitialize={true} 
              initialValues={initValues}
              validationSchema={SignUpSchema}
              onSubmit={(values)=>{
                  storeActions.signUp({user: values}, navigate);
                }
              }
            >
            {({ errors, touched }) => (
              <Form>
                <Grid container  style={{padding: 20}}  className="signup-container">
                  <Grid item>
                    <Typography variant="span" className="black-color font-2" style={{fontSize: 32, fontWeight: 700}}>
                      {t("We’d love to show you our tool.")}
                    </Typography>
                  </Grid>
                  <div className="v-space-5"></div>

                  <Grid  container  spacing={2}>
                    <Grid container item lg={12} className="d-f fd-c">
                      <Typography variant="span" className="second-color font-2" style={{fontSize: 16}}>
                        {t("First name")}
                      </Typography>
                      <div className="v-space-3"></div>
                      <Field  id="first_name" className="font-2 field w-100" name="first_name" placeholder={t("First Name")} />
                      <div className="v-space-1"></div>
                      {errors.first_name && touched.first_name ? <div className="error-color">{errors.first_name}</div> : null}
                    </Grid>

                    <Grid container item lg={12} className="d-f fd-c">
                      <Typography variant="span" className="second-color font-2" style={{fontSize: 16}}>
                        {t("Last Name")}
                      </Typography>
                      <div className="v-space-3"></div>
                      <Field  id="last_name" className="font-2 field w-100" name="last_name" placeholder={t("Last Name")} />
                      <div className="v-space-1"></div>
                      {errors.last_name && touched.last_name ? <div className="error-color">{errors.last_name}</div> : null}
                      <div className="v-space-3"></div>
                    </Grid>
                  </Grid>

                  <Grid container item lg={12} className="d-f fd-c">
                    <Typography variant="span" className="second-color font-2" style={{fontSize: 16}}>
                      {t("Email")}
                    </Typography>
                    <div className="v-space-3"></div>
                    <Field   id="email" className="font-2 field w-100" name="email" placeholder={t("Email")} />
                    <div className="v-space-1"></div>
                    {errors.email && touched.email ? <div className="error-color">{errors.email}</div> : null}
                    <div className="v-space-3"></div>
                  </Grid>

                  

                  
                  <div className="v-space-5"></div>
                  <Grid  container spacing={5} item>
                    <Grid container item lg={6} className="ai-c">
                      <Link to={AppRoutes.signInPath}> 
                        <Typography variant="span" className="second-color font-2 underline" style={{fontSize: 16}}>
                         {t('Log In instead')}
                        </Typography>
                      </Link>
                    </Grid>
                    <Grid container item lg={6} className="jc-r">
                      <AppButton 
                        actionType="submit"
                        buttonSize={ButtonSizeEnum.LARGE}
                        sx={{fontWeight: 400}}
                        buttonLabel={t('Request a DEMO')}
                        buttonType={ButtonTypeEnum.DEFAULT}
                      />
                    </Grid>
                  </Grid>


                </Grid>
              </Form>
              )}
            </Formik>
          </Grid>
          <Grid item lg={5} className="d-f ai-c">
            <img src={demo} className="w-100" alt=""  />
          </Grid>
          <div className="v-space-10"></div>
        </Grid>
      </Container>
      <Footer/>
    </>
    )
}